import { render, staticRenderFns } from "./tstudentPlanes.vue?vue&type=template&id=e831ce7c&scoped=true"
import script from "./tstudentPlanes.vue?vue&type=script&lang=js"
export * from "./tstudentPlanes.vue?vue&type=script&lang=js"
import style0 from "./tstudentPlanes.vue?vue&type=style&index=0&id=e831ce7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e831ce7c",
  null
  
)

export default component.exports